"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./SortArrow.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var renderSortArrow = function renderSortArrow(_ref) {
  var id = _ref.id,
      sortType = _ref.sortType,
      sortColumn = _ref.sortColumn;
  var arrowClass = 'data-table__sort-arrow';
  if (sortType === 'asc' && sortColumn === id) arrowClass += ' data-table__sort-arrow--asc';
  if (sortType === 'desc' && sortColumn === id) arrowClass += ' data-table__sort-arrow--desc';
  return _react.default.createElement("span", {
    className: arrowClass
  });
};

renderSortArrow.propTypes = {
  id: _propTypes.default.string,
  sort: _propTypes.default.string,
  sortColumn: _propTypes.default.string
};
var _default = renderSortArrow;
exports.default = _default;